/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { animated } from '@react-spring/web';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { styles } from './sticky-header.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface StickyHeaderProps {
    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;

    /**
     * Child elements
     */
    children?: ReactNode;

    /**
     * Style Object
     */
    style?: Record<string, unknown>;
}

const StyledStickyHeader = styled(animated.header).withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const StickyHeader: FunctionComponent<StickyHeaderProps> = ({
    children,
    ...otherProps
}: StickyHeaderProps) => {
    return (
        <StyledStickyHeader
            {...otherProps}
            data-testid="sticky-header"
            id="sticky-header"
        >
            {children}
        </StyledStickyHeader>
    );
};
